import { NgModule } from '@angular/core';
import { HybridClassesPageComponent } from './hybrid-classes-page/hybrid-classes-page.component';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { CommonModule } from '@angular/common';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  imports: [CommonModule, SafeUrlPipeModule, UserwaySyncModule],
  exports: [HybridClassesPageComponent],
  declarations: [HybridClassesPageComponent],
  entryComponents: [HybridClassesPageComponent]
})
export class HybridClassesModule { }



// WEBPACK FOOTER //
// ./ts/app/hybrid-classes/hybrid-classes.module.ts